<script setup>
import {mapErrors} from "@/utilities";
import {useForm} from "@inertiajs/vue3";
import {inject, ref} from "vue";
import Button from "@/Components/Buttons/Button.vue";
import Html from "@/Components/Html.vue";
import Form from "@/Components/Input/Form.vue";
import Group from "@/Components/Input/Group.vue";

const route = inject("route");

defineProps({
  introduction: String,
  sidebar: String,
});

const form = useForm({
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  order_number: "",
  subject: "",
  message: "",
});

function submitForm() {
  form.post(route("public.forms.contact"), {
    preserveScroll: true,
    onError: (errors) => (form.errors = mapErrors(errors)),
    onSuccess: () => (submitted.value = true),
  });
}

const submitted = ref(false);
</script>

<template>
    <div class="container my-12 flex flex-col-reverse gap-8 md:gap-16 lg:flex-row">
        <div class="w-full md:w-80">
            <Html
                class="prose mb-8 md:mb-16"
                :html="sidebar"
            />
        </div>

        <div class="flex-1">
            <Html
                class="prose mb-8 md:mb-16"
                :html="introduction"
            />
            <template v-if="!submitted">
                <Form class="flex flex-col gap-4">
                    <Group>
                        <FormKit
                            v-model="form.first_name"
                            :errors="form.errors?.first_name"
                            :label="$t('First name')"
                            :value="form.first_name"
                            name="first_name"
                            type="text"
                        />
                        <FormKit
                            v-model="form.last_name"
                            :errors="form.errors?.last_name"
                            :label="$t('Last name')"
                            :value="form.last_name"
                            name="last_name"
                            type="text"
                        />
                    </Group>

                    <Group>
                        <FormKit
                            v-model="form.email"
                            :errors="form.errors?.email"
                            :label="$t('Email')"
                            :value="form.email"
                            name="email"
                            type="email"
                        />

                        <FormKit
                            v-model="form.phone_number"
                            :errors="form.errors?.phone_number"
                            :label="$t('Phone number')"
                            :value="form.phone_number"
                            name="phone_number"
                            type="text"
                        />
                    </Group>

                    <FormKit
                        v-model="form.order_number"
                        :errors="form.errors?.order_number"
                        :label="$t('Order number')"
                        :value="form.order_number"
                        name="order_number"
                        type="text"
                    />

                    <FormKit
                        v-model="form.subject"
                        :errors="form.errors?.subject"
                        :label="$t('Subject')"
                        :value="form.subject"
                        name="subject"
                        type="text"
                    />

                    <FormKit
                        v-model="form.message"
                        :errors="form.errors?.message"
                        :label="$t('Message')"
                        :value="form.message"
                        name="message"
                        type="textarea"
                    />

                    <div class="flex justify-end">
                        {{ $t('* Required fields') }}
                    </div>

                    <div class="mt-4 flex justify-center lg:justify-end">
                        <Button
                            :form="form"
                            :label=" $t('Send')"
                            @click="submitForm"
                        />
                    </div>
                </Form>
            </template>
            <template v-else>
                <Html
                    class="mb-8 md:mb-16"
                    :html="$t('Thank you for your message.')"
                />
            </template>
        </div>
    </div>
</template>
